var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgXCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#FF7272",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5l5 5",
    transform: "translate(-344 -1054) translate(344 1054) translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5l5 5",
    transform: "translate(-344 -1054) translate(344 1054) translate(6 6) matrix(-1 0 0 1 6 0)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FF7272"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.756.172C3.928.172 0 4.1 0 8.93c0 4.828 3.928 8.756 8.756 8.756s8.756-3.928 8.756-8.756c0-4.829-3.928-8.757-8.756-8.757zm0 16.1c-4.05 0-7.345-3.294-7.345-7.343 0-4.052 3.296-7.346 7.345-7.346 4.05 0 7.344 3.296 7.344 7.346 0 4.05-3.294 7.344-7.344 7.344z",
    transform: "translate(-344 -1054) translate(344 1054)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/x_circle.66845dc0.svg";
export { ForwardRef as ReactComponent };